import React from "react";
import { Icon, Card, Flex, type IconType } from "@jsq/ds/core";
import { paymentPrefDisplayCardIcon } from "./styles_vanilla.css";

export type PaymentPrefDisplayCardContainerProps = {
  children: React.ReactNode;
  actionComponent?: React.ReactNode;
  iconType: IconType;
};

export const PaymentPrefDisplayCardContainer: React.FC<
  PaymentPrefDisplayCardContainerProps
> = ({ children, actionComponent, iconType }: PaymentPrefDisplayCardContainerProps) => {
  return (
    <Card className="PaymentPrefDisplayCard" padding="md">
      <Flex alignItems="flex-start" flexDirection="row" justifyContent="space-between">
        <Flex flexDirection="row" alignItems="flex-start" gap={20}>
          <Icon type={iconType} size="x-large" className={paymentPrefDisplayCardIcon} />
          {children}
        </Flex>
        {actionComponent}
      </Flex>
    </Card>
  );
};
